import React, { useState, useEffect } from 'react';
import { Box, Container, Snackbar, Alert, useTheme } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import FloatingPet from '../Common/FloatingPet';
import AnnouncementBanner, { checkShouldShowAnnouncement } from '../Common/AnnouncementBanner';
import { hideNotification } from '../../store/actions/uiActions';

const AppLayout = ({ children }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { notification } = useSelector((state) => state.ui);
  const [bannerVisible, setBannerVisible] = useState(checkShouldShowAnnouncement);

  // 处理通知关闭
  const handleCloseNotification = () => {
    dispatch(hideNotification());
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: 'rgba(228, 228, 228, 0.6)',
      }}
    >
      {/* 升级公告横幅 */}
      <AnnouncementBanner
        onVisibilityChange={(visible) => setBannerVisible(visible)}
      />

      {/* 顶部导航栏 */}
      <AppHeader bannerVisible={bannerVisible} />

      {/* 主要内容区域 */}
      <Container
        component="main"
        maxWidth="xl"
        sx={{
          flexGrow: 1,
          py: { xs: 3, md: 4 },
          px: { xs: 2, sm: 3, md: 4 },
          pt: bannerVisible ? '100px' : { xs: 3, md: 4 },
          transition: 'padding-top 0.3s ease'
        }}
      >
        <Box
          sx={{
            backgroundColor: 'transparent',
            borderRadius: '40px',
            boxShadow: 'none',
            overflow: 'hidden',
            p: { xs: 2, sm: 3 },
            height: '100%',
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          {children}
        </Box>
      </Container>
      
      {/* 底部Footer */}
      <AppFooter />
      
      {/* 萌宠悬浮组件 */}
      <FloatingPet />
      
      {/* 全局通知 */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        sx={{ 
          '& .MuiAlert-root': {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[3],
            py: 1,
            px: 2
          }
        }}
      >
        <Alert 
          onClose={handleCloseNotification} 
          severity={notification.type} 
          variant="filled"
          sx={{ 
            width: '100%',
            alignItems: 'center'
          }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AppLayout; 